import React from "react";
import { useTheme } from "../../theme/ThemeContext";
import "./Settings.css";

const Settings = () => {
  const { appearance, setAppearance, prefsLoading } = useTheme();

  return (
    <div id="settings-page-scope" className="settings-page">
      <div className="settings-card">
        <h1 className="settings-title">הגדרות</h1>
        <p className="settings-subtitle">בחר מצב תצוגה למכשיר זה (נשמר לחשבון שלך)</p>

        <section className="settings-section" aria-labelledby="appearance-heading">
          <h2 id="appearance-heading" className="settings-section-title">
            מראה
          </h2>
          <div className="appearance-toggle" role="group" aria-label="מצב תצוגה">
            <button
              type="button"
              className={`appearance-option ${
                appearance === "light" ? "appearance-option-active" : ""
              }`}
              disabled={prefsLoading}
              onClick={() => setAppearance("light")}
            >
              בהיר
            </button>
            <button
              type="button"
              className={`appearance-option ${
                appearance === "dark" ? "appearance-option-active" : ""
              }`}
              disabled={prefsLoading}
              onClick={() => setAppearance("dark")}
            >
              כהה
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Settings;
